
<template>
  <div>
      数据
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/information/information.vue